import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Typography,
} from "@mui/material";

function ConfirmarSobrescrituraDialog({ open, onClose, objetivos, onConfirm }) {
  const [seleccionados, setSeleccionados] = useState({});

  // Manejar la selección de objetivos
  const handleSeleccionar = (id) => {
    setSeleccionados((prev) => ({
      ...prev,
      [id]: !prev[id], // Alternar entre seleccionado y no seleccionado
    }));
  };

  // Confirmar la sobrescritura
  const handleConfirmar = () => {
    const objetivosSeleccionados = objetivos.filter((obj) => seleccionados[obj.id_objetivo]);
    onConfirm(objetivosSeleccionados);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar sobrescritura</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Los siguientes objetivos ya tienen un monto registrado. Selecciona cuáles deseas sobrescribir:
        </Typography>
        <List>
          {objetivos.map((obj) => (
            <ListItem key={obj.id_objetivo}>
              <Checkbox
                checked={!!seleccionados[obj.id_objetivo]}
                onChange={() => handleSeleccionar(obj.id_objetivo)}
              />
              <ListItemText
                primary={`${obj.nombre_apellido} - ${obj.nombre_sucursal}`}
                secondary={`Monto actual: $${obj.monto_pesos || "No registrado"}`}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button onClick={handleConfirmar} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmarSobrescrituraDialog;